<template>	
	    <div class="hero-wrapper">
		        <div class="hero js-hero-area " v-bind:class="{ 'is-revealed': active }">
		            <div class="container">               
		    			<h2>Produkty<br />&nbsp;i&nbsp;<span>usługi</span></h2>
						<p>
							<router-link class="btn btn-hero" to="/co-mozemy-dla-ciebie-zrobic" title="Produkty software'owe">Zobacz ofertę</router-link>
						</p>
		            </div>
		        </div>
		<div class="hero-boxes container">
            <div class="hero-box" style="width:100%">                
    			<h2 data-mh="hero-box-title"><router-link to="/co-mozemy-dla-ciebie-zrobic" style="color:red">System Pomiaru Temperatury</router-link></h2>
					<p data-mh="hero-box-description">Mając na uwadze niezwykle istotny aspekt, jakim jest w obecnym czasie kontrola temperatury osób wchodzących do budynków instytucji lub firm, przedstawiamy System Pomiaru Temperatury (SPT). Proponowane rozwiązanie daje możliwość wykonania pomiaru temperatury w sposób bezobsługowy, z dużą dokładnością i wydajnością.</p>
					<p data-mh="hero-box-arrow">
						<router-link to="/co-mozemy-dla-ciebie-zrobic" title="Co możemy dla Ciebie zrobić?">&rarr;</router-link>
					</p>
            </div>
        </div>
        <div class="hero-boxes container">
            <div class="hero-box">                
    			<h2 data-mh="hero-box-title"><router-link to="/kim-jestesmy">Kim jesteśmy?</router-link></h2>
					<p data-mh="hero-box-description">Firma Kontur.IT powstała na bazie wieloletniego doświadczenia na rynku informatycznym, opartego na usługach i własnych produktach softwareowych.</p>
					<p data-mh="hero-box-arrow">
						<router-link to="/kim-jestesmy" title="Kim jesteśmy?">&rarr;</router-link>
					</p>
            </div>
            <div class="hero-box">               
    			<h2 data-mh="hero-box-title">
    				<router-link to="/co-mozemy-dla-ciebie-zrobic">Co możemy dla Ciebie zrobić?</router-link>
    			</h2>
				<p data-mh="hero-box-description">Najlepsze rozwiązania rodzą się w drodze dyskusji! Dzięki kontaktowi z Klientem oraz wsp&oacute;lnej analizie potrzeb dostosujemy nasze produkty do specyficznych wymagań obecnych i przyszłych Partner&oacute;w Biznesowych.</p>
				<p data-mh="hero-box-arrow">
					<router-link to="/co-mozemy-dla-ciebie-zrobic" title="Co możemy dla Ciebie zrobić?">&rarr;</router-link>
				</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Home',
  data: function () {
    return {
      active: false
    }
  },
	mounted() {
		setTimeout(function(){
            this.active=true;
        }.bind(this), 100);	
	}
}
</script>
